import type { OptionsDocument, UserPreferences } from 'paintscout'
import get from 'lodash/get'
import { getFeatures } from './get-features'

export function getFeature(args: { options: OptionsDocument; preferences?: UserPreferences; path: string }): any {
  const { options, preferences, path } = args

  const features = getFeatures({ options, preferences })

  return get(features, path, false)
}
